import React from "react";
import {QRCodeSVG} from 'qrcode.react';
import './styles.css';
const QRCodeGenerator = ({ text }) => {
  return (
    <div className="qr-code-container">
        <div className="qr-code-wrapper">
        <QRCodeSVG value={text} size={180} />
        
        </div>
        <span className="qr-code-span">Escanéa el QR y descargá el abstract o ePoster</span>
    </div>
  );
};

export default QRCodeGenerator;